import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  HostBinding,
  inject,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { NgStyle } from '@angular/common';

import { RotationElementDirective } from '../../core/directives/rotation-element.directive';
import { IPriorityShape } from '../../core/interfaces';
import { ResizeService } from '../../core/services/app-services';
import { GuidWrapper } from '../../core/types';
import { AuditoriumShapeDirective } from '../../core/directives/auditorium-shape.directive';
import { CX_CORE_STANDALONE } from '../../../shared/cx-core-standalone';
@Component({
  imports: [ ...CX_CORE_STANDALONE, NgStyle ],
  selector: 'app-priority-shape',
  templateUrl: './priority-shape.component.html',
  styleUrls: ['./priority-shape.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'priority-shape draggable',
  },
  hostDirectives: [
    RotationElementDirective,
    {
      directive: AuditoriumShapeDirective,
      inputs: ['componentRef']
    }
  ]
})
export class PriorityShapeComponent implements AfterViewInit, OnInit {

  @ViewChild('priorityShape') set priorityShapeElement(value: ElementRef<HTMLElement>) {
    if (!this._priorityShapeElement) {
      this._priorityShapeElement = value.nativeElement;
      this._rotationDirective.elementToRotate = value.nativeElement;
    }
  }

  @Input() set dataObject(value: GuidWrapper<IPriorityShape>) {
    if (value) {
      this._dataObject = value;

      this.width = `${value.w}px`;
      this.height = `${value.h}px`;
      this.x = `${value.x}px`;
      this.y = `${value.y}px`;
      this.rotation = `rotate(${value.rotate}deg)`;

      this._cdr.detectChanges();
    }
  }

  @Input() set priorityDensity(value: boolean) {
    this._priorityDensity = value;
    this._cdr.detectChanges();
  }

  @Input() rotation: string;
  @HostBinding('style.position') @Input() position: string;
  @HostBinding('attr.draggable') @Input() draggable = false;
  @HostBinding('style.left') @Input() x: string;
  @HostBinding('style.top') @Input() y: string;
  @HostBinding('style.width') @Input() width: string;
  @HostBinding('style.height') @Input() height: string;
  @HostBinding('attr.id') @Input() id: number;
  @HostBinding('attr.data-drag-id') @Input() dragId: string;
  /**
   * Helps with identifying priority shapes in the DOM
   */
  @HostBinding('attr.data-priority-shape') priorityShape = true;

  public readonly auditoriumShapeDirective = inject(AuditoriumShapeDirective, { host: true });

  private _resizeService: ResizeService;
  private _dataObject: GuidWrapper<IPriorityShape>;
  private _priorityDensity: boolean;
  private _priorityShapeElement: HTMLElement;
  private readonly _elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly _cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly _destroyRef: DestroyRef = inject(DestroyRef);
  private readonly _rotationDirective: RotationElementDirective = inject(RotationElementDirective);

  public ngOnInit(): void {
    this._resizeService = new ResizeService(this._destroyRef);
  }

  public ngAfterViewInit(): void {
    this._resizeService.createResizePoints(this._elementRef.nativeElement);
  }

  public get priorityDensity(): boolean {
    return this._priorityDensity;
  }

  public get elementRef(): ElementRef<HTMLElement> {
    return this._elementRef;
  }

  public get dataObject(): GuidWrapper<IPriorityShape> {
    return this._dataObject;
  }
}
